import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateListSearch } from '@/shared/lib/listSearch';

export const requestsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/requests',
  component: lazyRouteComponent(() => import('./pages/RequestsPage'), 'RequestsPage'),
  validateSearch: validateListSearch,
});

export const requestsRoutes = [requestsRoute];
